import React from "react";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@material-ui/core";
import Label from "src/components/Label";

export default function ModalAccionEmpleado({
  open,
  onClose,
  selectedActivity,
  ultimasAccionesEmpleado = [],
  loadingUltimasAcciones = false,
  obtenerRuta = (u) => u,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Detalle de actividad</DialogTitle>
      <DialogContent dividers>
        {selectedActivity ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" gap={2}>
                <Avatar
                  src={selectedActivity.foto_url}
                  style={{ width: 56, height: 56, backgroundColor: "#d57a23" }}
                >
                  {(selectedActivity.nombre || "?").charAt(0).toUpperCase()}
                </Avatar>
                <Box>
                  <Typography variant="h6" style={{ fontWeight: 700 }}>
                    {selectedActivity.nombre && selectedActivity.apellidos
                      ? `${selectedActivity.nombre} ${selectedActivity.apellidos}`
                      : selectedActivity.refEmpleado || "Empleado"}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {selectedActivity.refEmpleado || "Sin referencia"}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                Últimas 10 acciones
              </Typography>

              {loadingUltimasAcciones ? (
                <Typography variant="body2" color="textSecondary">
                  Cargando acciones...
                </Typography>
              ) : ultimasAccionesEmpleado.length > 0 ? (
                <List style={{ maxHeight: 300, overflow: "auto" }}>
                  {ultimasAccionesEmpleado.map((accion, index) => (
                    <React.Fragment key={accion.id || index}>
                      <ListItem
                        alignItems="flex-start"
                        style={{ paddingTop: 8, paddingBottom: 8 }}
                      >
                        <ListItemText
                          primary={
                            <Label
                              variant="ghost"
                              color="info"
                              style={{
                                display: "inline-flex",
                                maxWidth: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {obtenerRuta(accion.urlAccion)}
                            </Label>
                          }
                          secondary={
                            <span style={{ color: "#6b7280" }}>
                              {accion.fechaAccion || "—"} •{" "}
                              {accion.horaAccion || "—"}
                            </span>
                          }
                        />
                      </ListItem>
                      {index < ultimasAccionesEmpleado.length - 1 && (
                        <Divider component="li" />
                      )}
                    </React.Fragment>
                  ))}
                </List>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No hay acciones registradas para este empleado.
                </Typography>
              )}
            </Grid>
          </Grid>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
